<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="840"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" :rules="Rules" label-position="top">
                <Divider orientation="left" class="text-primary">支出信息</Divider>
                <Row :gutter="32">
                    <Col span="24">
                        <FormItem label="采购信息" prop="buyer_id">
                            <Select v-model="Forms.buyer_id" clearable filterable :disabled="is_select"  placeholder="采购信息" class="width-100">
                                <Option v-for="(item,index) in buyerList" :key="index" :value="item.buyer_id">{{item.title}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="采购金额" prop="money">
                            <Input v-model="Forms.money" type="number" clearable placeholder=""/>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="付款类型" prop="type_id">
                            <Select v-model="Forms.type_id" clearable filterable  placeholder="付款类型" class="width-100">
                                <Option v-for="(item,index) in expendTypeList" :key="index" :value="item.id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="采购清单" prop="image" :rules="[{required: true, type:'array', message: '请上传采购清单', trigger: 'change'}]">
                            <Upload
                                :show-upload-list="false"
                                :action="upload_url"
                                :headers = "{'token': $store.state.token}"
                                :format="['jpg','jpeg','png','gif']"
                                :max-size="10 * 1024"
                                :on-success="handleSuccess"
                                :on-format-error="handleFormatError"
                                :on-exceeded-size="handleMaxSize"
                                :before-upload="handleBeforeUpload">
                                <div class="uploads">
                                    <div class="upload-images-icon cursor" v-if="Forms.image.length < 10">
                                        <Icon type="md-cloud-upload" size="24" />
                                        <span>点击上传</span>
                                    </div>
                                    <div class="upload-images" v-for="(item,index) in Forms.image" :key="index" @click.stop="">
                                        <img :src="site_url + item">
                                        <div class="show" @click.stop="PhotoView(site_url + item)">预览</div>
                                        <div class="del" @click.stop="PhotoDelete(index)"><Icon type="md-close" /></div>
                                    </div>
                                </div>
                            </Upload>
                        </FormItem>
                    </Col>
                </Row>
                <Divider orientation="left" class="text-primary">收款账户</Divider>
                <Row :gutter="32">
                    <Col span="12">
                        <FormItem label="收款账户" prop="pay_bank_account">
                            <Input v-model="Forms.pay_bank_account" clearable placeholder="" :class="Forms.buyer_id?'width-70':'width-100'"/>
                            <span v-if="Forms.buyer_id">&nbsp;<Button type="primary" class="width-27"  ghost @click="getAccount">自动获取</Button></span>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="账户实名" prop="pay_bank_real_name">
                            <Input v-model="Forms.pay_bank_real_name" clearable placeholder="" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="开户银行" prop="pay_bank_name">
                            <Input v-model="Forms.pay_bank_name" clearable placeholder="" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="开户地址" prop="pay_bank_address">
                            <Input v-model="Forms.pay_bank_address" clearable placeholder="" />
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="32">
                    <Col span="24">
                        <FormItem label="收款备注" prop="remark">
                            <Input v-model="Forms.remark" type="textarea" :rows="4" clearable placeholder="备注信息" />
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">保存</Button>
            </div>
        </div>

        <!-- 预览图片 -->
        <Modal
            v-model="is_view_box"
            title="预览"
            :width="840"
            :mask-closable="true"
            :footer-hide="true"
            @on-cancel="PhotoViewClose()">
            <div class="flex-image-box">
                <img :src="view_url" class="flex-image-box-show">
            </div>
        </Modal>

    </Drawer>
</template>

<script>

import {getBuyerAccount, getBuyerSelectList} from "@/apis/buyer";
import {getExpendConfig, getExpendDetail, onSaveExpend} from "@/apis/expend";

export default {
    name: 'ExpendCreate',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '项目支出',
            isBox : false,
            expendTypeList: [],
            buyerList: [],

            upload_url : this.$uploadApi,
            site_url : this.$siteApi,
            is_view_box : false,
            view_url : '',
            is_select: false,

            Forms : {
                expend_id: '',
                buyer_id: '',
                money: '',
                type_id: '',
                image: [],
                pay_bank_account: '',
                pay_bank_real_name: '',
                pay_bank_name: '',
                pay_bank_address: '',
                remark: ''
            },
            Rules : {
                buyer_id: [
                    { required: true, type: 'number',  message: '请选择采购信息', trigger: 'change',  transform(value) { return parseInt(value)}}
                ],
                money: [
                    { required: true, type: 'number',  message: '请输入付款金额', trigger: 'blur',  transform(value) { return parseFloat(value)} }
                ],
                type_id: [
                    { required: true, type: 'number',  message: '请选择付款类型', trigger: 'change',  transform(value) { return parseInt(value)}  }
                ],
                pay_bank_account: [
                    { required: true, message: '请输入收款账户', trigger: 'blur'}
                ],
                pay_bank_real_name: [
                    { required: true, message: '请输入收款账户开户实名', trigger: 'blur'}
                ]
            }
        }
    },
    methods: {
        /**
         功能：图片预览
         time: 2025-17-15 10:17:00
         **/
        PhotoView(url){
            if(url){
                this.view_url = url;
                this.is_view_box = true;
            }
        },
        /**
         功能：图片删除
         time: 2025/12/15 10:21
         **/
        PhotoDelete(index){
            let that = this;
            that.Forms.image.splice(index , 1);
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        handleSuccess(res){
            let that = this;
            if(res.code == 100){
                this.Forms.image.push(res.data.url);
            }else{
                that.$Message.error({ background: true,duration:3, content: res.msg});
            }
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        handleFormatError(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '只支持 jpg | png | gif 文件 ' });
            return false;
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        handleMaxSize(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '图片大小不能超出 10M' });
            return false;
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        handleBeforeUpload(){
            let that = this;
            if(that.Forms.image.length >= 10){
                that.$Message.error({ background: true,duration:3, content: '最多只能上传 10 张图' });
                return false;
            }
            return true;
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        PhotoViewClose(){
            this.is_view_box = false;
            this.view_url = '';
        },

        /**
         功能：
         time: 2025/12/26 16:14
         **/
        getAccount(){
            let that = this;
            if(!that.Forms.buyer_id){
                that.$Message.error({ background: true,duration:3, content: '请选择采购信息'});
                return;
            }
            getBuyerAccount(that.Forms.buyer_id).then(e => {
                let data = e.data;
                that.Forms.pay_bank_account = data.bank_account ?? '';
                that.Forms.pay_bank_real_name = data.bank_real_name ?? '';
                that.Forms.pay_bank_name = data.bank_name ?? '';
                that.Forms.pay_bank_address = data.bank_address ?? '';
            })
        },

        /**
         功能：
         time: 2025/12/25 16:29
         **/
        GetConfig(){
            let that = this;
            getExpendConfig().then(e=>{
                that.expendTypeList = e.data.expendTypeList ?? [];
            })
            getBuyerSelectList({}).then(e=>{
                that.buyerList = e.data ?? [];
            })
        },
        /**
         功能：
         time: 2026/1/6 14:57
         **/
        GetDetail(id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getExpendDetail(id).then(e => {
                let data = e.data;
                for (let v of Object.keys(that.Forms)) {
                    if(v === 'buyer_id' || v === 'type_id') {
                        that.Forms[v] = parseInt(data[v]);
                    }else if(v === 'image') {
                        that.Forms[v] = data[v] ? data[v] : [];
                    }else{
                        that.Forms[v] = data[v];
                    }
                }
                that.GetConfig(e.data.project_id);
            })
        },
        /**
         功能：
         time: 2025/12/25 16:08
         **/
        add(){
            this.isBox = true;
            this.GetConfig();
        },
        /**
         功能：
         time: 2026/1/6 11:47
         **/
        edit(expend_id){
            this.isBox = true;
            this.is_select = true;
            if(expend_id) this.GetDetail(expend_id);
        },
        /**
         功能：
         time: 2025/12/25 17:38
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    that.$store.commit('SET_LOADING' , true);
                    onSaveExpend(that.Forms).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },
        /**
         功能：
         time: 2025/12/27 10:00
         **/
        FormReset(){
            this.isBox = false;
            this.title = '项目支出';
            this.$refs['Forms'].resetFields();
            this.Forms.expendTypeList = [];
            this.Forms.projectList = [];
            this.is_select = false;
            this.Forms.buyerList = [];
            this.Forms.expend_id = '';
            this.Forms.image = [];
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
.forms {
    .ivu-form-item {
        //margin-bottom: 0 !important;
    }
}
.spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
}
.spin-text {
    font-size: 12px;
    padding-top: 10px;
}
</style>
